
export function mapGetOrSet<
    TMapKey,
    TMapValue
>(
    map: Map<TMapKey, TMapValue>,
    key: TMapKey,
    value: TMapValue
): TMapValue {
    return map.get(key) ?? (map.set(key, value), map.get(key))!;
}
